import { gql, useQuery } from '@apollo/client';

export const GET_HEALTH_INSURANCE_BY_IDS = gql`
  query getHealthInsuranceByIds($ids: [String!]!) {
    getHealthInsuranceByIds(ids: $ids) {
      _id
      name
    }
  }
`;
export const useGetHealthInsuranceByIds = (ids?: string[]) => {
  const { data, loading } = useQuery(GET_HEALTH_INSURANCE_BY_IDS, {
    variables: {
      ids,
    },
    skip: !ids?.length,
    fetchPolicy: 'cache-and-network',
  });

  return {
    healthInsurance: data?.getHealthInsuranceByIds || [],
    loading,
  };
};
